// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';

// import { data, useNavigate } from 'react-router-dom';
// import Config from '../config';
// import ErrorPage from "../UserManagement/ErrorPage"
// import { useLocation } from "react-router-dom";
// import './SsoPlant.css';


// const SSOPlant = () => {
//   const [assignments, setAssignments] = useState([]);
//   const [error, setError] = useState('');
//   const [plants, setPlants] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const hasCalled = useRef(false);

//   const [userId, setUserId] = useState(null);
//   const [roleId, setRoleId] = useState(null);
//   const [plantId, setPlantId] = useState("");
//   const [plantName, setPlantName] = useState("");
//   const [access_token, setAccessToken] = useState(null);


//   // useEffect(() => {
//   //    const fetchPayloadData = async () => {
//   //      try {
//   //        const res = await fetch(`/api/payload/`, {
//   //          credentials: "include", // send HttpOnly cookie
//   //        });

//   //        if (res.ok) {
//   //          const data = await res.json();
//   //          console.log("Change Plant : ",data)

//   //          if (data?.payload) {
//   //            const payload = data.payload;
//   //            setUserId(payload.user_id);
//   //            console.log("User Id ",payload.user_id)
//   //            setRoleId(payload.role_id);
//   //            console.log(payload.user_id)
//   //            setPlantId(payload.plant_id);


//   //            // setPlantId(payload.plant_id);
//   //            // setAccessToken(payload.access_token); // if returned in payload
//   //          } else {
//   //            setError("No valid payload data found.");
//   //          }
//   //        } else {
//   //          setError("Failed to fetch payload data.");
//   //        }
//   //      } catch (err) {
//   //        console.error("Error fetching payload:", err);
//   //        setError("Error fetching payload data.");
//   //      }
//   //    };

//   //    fetchPayloadData();
//   //  }, []);



//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const code = params.get("code");

//     if (code) {
//       console.log("SSO CODE:", code);

//       // ✅ store before it disappears
//       sessionStorage.setItem("sso_code", code);
//     }
//   }, []);

//   //    useEffect(() => {
//   //   const exchangeSSO = async () => {
//   //     try {
//   //       const queryParams = new URLSearchParams(location.search);
//   //       const code = queryParams.get("code");
//   //       console.log(code,"codee")

//   //       if (!code) {
//   //         setError("No SSO code found in URL");
//   //         return;
//   //       }

//   //       // Call your Django API
//   //       const res = await fetch(`/sso/sync_data/`, {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({ code }),
//   //         // credentials: "include", // 🔥 important for cookies
//   //       });

//   //       const data = await res.json();


//   //       if (!res.ok || !data.success) {
//   //         setError(data.error || "SSO exchange failed");
//   //         return;
//   //       }

//   //       // ✅ Success → now cookies are set
//   //       console.log("SSO login successful");

//   //     } catch (err) {
//   //       console.error(err);
//   //       setError("SSO API failed");
//   //     }
//   //   };

//   //   exchangeSSO();
//   // }, []);


//   // Fetch assigned plants for the user
//   // useEffect(() => {
//   //     const fetchAssignments = async () => {
//   //         try {
//   //             const res = await axios.get(`/api/userAndPlant/`, {
//   //                 params: { user_id: userId },
//   //               withCredentials:true
//   //             });

//   //             setAssignments(res.data.assignments || []);
//   //             // console.log(res.data.assignments ,"plants")
//   //             setPlants(res.data.plants);
//   //             setRoles(res.data.roles);
//   //         } catch (err) {
//   //             setError('Error fetching plant assignments.');
//   //         }
//   //     };

//   //     fetchAssignments();
//   // }, [userId]);




//   //     const handlePlantSelection = async (plantId, roleId) => {
//   //   const selectedPlant = plants.find((p) => p.Id === plantId);
//   //   const plantName = selectedPlant ? selectedPlant.Name : "Unnamed Plant";

//   //   const selectedRole = roles.find((r) => r.Id === roleId);
//   //   const roleName = selectedRole ? selectedRole.Name : "Unnamed Role";

//   //   try {
//   //   await axios.post(
//   //     `/api/up/`,
//   //     { plant_id: plantId, role_id: roleId },
//   //     {
//   //       headers: {
//   //         "Content-Type": "application/json",

//   //       },
//   //       withCredentials: true, // ensures cookies are sent
//   //     }
//   //   );
//   // } catch (err) {
//   //   console.error("Failed to update session", err);
//   // }


//   //   // now navigate based on role
//   //   switch (roleId) {
//   //             case 1: navigate("/ServiceProviderHome"); break;
//   //             case 2: navigate("/SuperAdminHome"); break;
//   //             case 3: navigate("/AdminHome"); break;
//   //             case 4: navigate("/InitatorHome"); break;
//   //             case 5: navigate("/ApproverHome"); break;
//   //             case 6: navigate("/InitatorHome"); break;
//   //             case 7: navigate("/ViewHome"); break;
//   //             case 8: navigate("/managers/dashboard"); break;
//   //             case 9: navigate("/hr/dashboard"); break;
//   //             case 10: navigate("/user/dashboard"); break;
//   //             default: navigate("/DefaultHome"); break;
//   //   }
//   // };


//   //     // console.log(sessionStorage)
//   //     if (!userId) {
//   //         return <ErrorPage />;
//   //     }

//   const exchangeSSO = async () => {
//     try {
//       const queryParams = new URLSearchParams(location.search);
//       const code = queryParams.get("code");

//       if (!code) {
//         setError("No SSO code found in URL");
//         return;
//       }

//       const res = await fetch(`/sso/sync_data/`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ code }),
//       });

//       const data = await res.json();
//       console.log(data,
//         "PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP"
//       );

//       // ❌ ERROR CASE → but now includes plants
//       if (!res.ok || !data.success) {
//         setError(data.error || "SSO exchange failed");

//         // ✅ STORE plants from backend
//         if (data.plants) {
//           setPlants(data.plants);
//           console.log(data.plants, "SSSSSSSSSS")
//         }

//         return;
//       }

//       // ✅ SUCCESS CASE (optional if you also send plants on success)
//       if (data.plants) {
//         setPlants(data.plants);
//         console.log(data.plants, "SDDDDDDDDDDDDDD")
//       }

//     } catch (err) {
//       console.error(err);
//       setError("SSO API failed");
//     }
//   };
//   useEffect(() => {
//     if (hasCalled.current) return;  // 🚫 stop second call
//     hasCalled.current = true;

//     exchangeSSO();
//   }, []);


//   // return (
//   //   <div>
//   //     <div
//   //       className="contentMain">
//   //       <div className="mt-4">
//   //         <br />
//   //         <div
//   //           className="border-radius-8 p-3 mt-3">

//   //           <div className="d-flex flex-wrap justify-content-center text-center">



//   //             {plants.map((plant, index) => (
//   //               <div
//   //                 key={index}
//   //                 className="col-md-3 bg-white ml-3 mb-3"
//   //                 style={{ cursor: 'pointer' }}
//   //                 onClick={() => {
//   //                   setPlantId(plant.plantId);
//   //                   setPlantName(plant.plantName);
//   //                   console.log("Selected Plant:", plant);
//   //                 }}
//   //               >
//   //                 <div className="p-4 font18">
//   //                   {plant.plantName}
//   //                   <br />
//   //                   <small>{plant.location}</small>
//   //                   {plant.isBasePlant && (
//   //                     <div style={{ color: "green" }}>Base Plant</div>
//   //                   )}
//   //                 </div>
//   //               </div>
//   //             ))}
//   //           </div>
//   //         </div>

//   //       </div>
//   //     </div>
//   //   </div>
//   // );
// //   return (
// //     <div className="contentMain">
// //   <div className="mt-5 px-3">
// //   <h2 className="text-center mb-5 fw-bold text-dark">
// //     Select Your Plant
// //   </h2>

// //   <div className="row g-4 justify-content-center">
// //     {plants.map((plant, index) => (
// //       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12" key={index}>   {/* Smaller width */}
// //         <div
// //           className="card h-100 shadow-sm border-0 rounded-3 overflow-hidden hover-card small-plant-card"
// //           style={{ cursor: 'pointer' }}
// //           onClick={() => {
// //             setPlantId(plant.plantId);
// //             setPlantName(plant.plantName);
// //             console.log("Selected Plant:", plant);
// //           }}
// //         >
// //           {/* Top Accent Bar - Changed to Dark Gray */}
// //           <div className="bg-secondary" style={{ height: '5px' }}></div>

// //           <div className="card-body">
// //             <div className="d-flex justify-content-between align-items-start mb-3">
// //               {/* <div className="text-muted" style={{ fontSize: '2.4rem' }}>
// //                 🏭
// //               </div> */}

// //               {plant.isBasePlant && (
// //                 <span className="badge bg-success d-flex align-items-center gap-1">
// //                   <span className="rounded-circle bg-white" style={{ width: '8px', height: '8px' }}></span>
// //                   BASE
// //                 </span>
// //               )}
// //             </div>

// //             <h4 className="card-title fw-semibold text-dark mb-1">
// //               {plant.plantName}
// //             </h4>

// //             <p className="card-text text-muted mb-3" style={{ fontSize: '0.95rem' }}>
// //               {plant.location || "Location not available"}
// //             </p>
// //           </div>

// //           <div className="card-footer bg-light border-0 text-center">
// //             <span className="fw-medium text-dark">
// //               Select Plant <i className="bi bi-arrow-right"></i>
// //             </span>
// //           </div>
// //         </div>
// //       </div>
// //     ))}
// //   </div>
// // </div>
// //     </div>
// //   );

// return (
//   <div className="plant-selection-container">
//     <div className="plant-selection-title">
//       <h2>Select Your Plant</h2>
//     </div>

//     <div className="plant-grid">
//       {plants.map((plant, index) => (
//         <div
//           key={index}
//           className="plant-card"
//           onClick={() => {
//             setPlantId(plant.plantId);
//             setPlantName(plant.plantName);
//             console.log("Selected Plant:", plant);
//           }}
//           role="button"
//           tabIndex={0}
//           onKeyPress={(e) => {
//             if (e.key === 'Enter' || e.key === ' ') {
//               setPlantId(plant.plantId);
//               setPlantName(plant.plantName);
//             }
//           }}
//         >
//           <div className="plant-card-body">
//             <div className="plant-card-header">
//               <div className="plant-icon">🏭</div>
//               {plant.isBasePlant && (
//                 <span className="base-plant-badge">BASE PLANT</span>
//               )}
//             </div>

//             <h3 className="plant-name">{plant.plantName}</h3>
//             <p className="plant-location">
//               {plant.location || "Location not available"}
//             </p>
//           </div>

//           <div className="plant-card-footer">
//             <div className="select-plant-btn">
//               <span>Select Plant</span>
//               <i className="bi bi-arrow-right">→</i>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>

//     {/* Optional: Loading State */}
//     {plants.length === 0 && !error && (
//       <div className="plant-loading">
//         <div className="spinner-border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <p className="mt-3">Loading your plants...</p>
//       </div>
//     )}

//     {/* Optional: Error State */}
//     {error && (
//       <div className="plant-error">
//         <p>{error}</p>
//       </div>
//     )}
//   </div>
// );


// };

// export default SSOPlant;



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Config from '../config';
import ErrorPage from "../UserManagement/ErrorPage";
import { useLocation } from "react-router-dom";
import './SsoPlant.css';

const SSOPlant = () => {
  const [assignments, setAssignments] = useState([]);
  const [error, setError] = useState('');
  const [plants, setPlants] = useState([]);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const hasCalled = useRef(false);

  const [userId, setUserId] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [plantId, setPlantId] = useState("");
  const [plantName, setPlantName] = useState("");
  const [access_token, setAccessToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      console.log("SSO CODE:", code);
      sessionStorage.setItem("sso_code", code);
    }
  }, []);

  const exchangeSSO = async () => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const code = queryParams.get("code");

      if (!code) {
        setError("No SSO code found in URL. Please access the application again through SSO.");
        return;
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);

      const res = await axios.post(`/sso/sync_data/`, { code }, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        signal: controller.signal,
      });

      clearTimeout(timeoutId);
      const data = res.data;
      console.log(data, "SSO Response");

      if (data.user_data) {
        sessionStorage.setItem(
          "sso_user",
          JSON.stringify(data.user_data)
        );
      }

      if (res.status < 200 || res.status >= 300 || !data.success) {
        const errorMsg = data.error || "SSO exchange failed";
        if (errorMsg.toLowerCase().includes("already used") ||
          errorMsg.toLowerCase().includes("code already") ||
          res.status === 409) {  // 409 Conflict often means already used
          setError("Please access the application again through SSO.");
        } else {
          setError(errorMsg);
        }

        if (data.plants) {
          setPlants(data.plants);
          console.log(data.plants, "Plants from error response");
        }
        return;
      }

      if (data.plants) {
        setPlants(data.plants);
        console.log(data.plants, "Plants from success response");
      }

    } catch (err) {
      console.error(err);
      if (err.name === "AbortError") {
        setError("Request timeout. Please access the application again through SSO.");
      } else {
        setError("SSO API failed: " + (err.message || "Unknown error"));
      }
    }
  };

  useEffect(() => {
    if (hasCalled.current) return;
    hasCalled.current = true;
    exchangeSSO();
  }, []);


  const handlePlantSelection = async (plant) => {
    console.log("Selected Plant:", plant);

    try {
      // ✅ Call backend to update JWT
      const res = await axios.post(
        "/sso/select-plant/",
        {
          plant_uid: plant.plantUid,  // 🔥 IMPORTANT (use UID, not ID)
          plants: plants,
          user_data: JSON.parse(sessionStorage.getItem("sso_user"))
        },
        {
          withCredentials: true // 🔥 REQUIRED for cookies
        }
      );

      console.log(res.data, "Plant selection response");

      if (!res.data.success) {
        setError(res.data.error || "Plant selection failed");
        return;
      }

      // ✅ Optional: store in session
      sessionStorage.setItem("selectedPlantUid", plant.plantUid);
      sessionStorage.setItem("selectedPlantName", plant.plantName);

      // ✅ Navigate AFTER success
      navigate("/users/dashboard");
      console.log("dfghjkl")

    } catch (err) {
      console.error(err);
      setError("Failed to select plant");
    }
  };
  return (
    <div className="plant-selection-container">
      <div className="plant-selection-title">
        <h2>Select Your Plant</h2>
      </div>

      <div className="plant-grid">
        {plants.map((plant, index) => (
          <div
            key={index}
            className="plant-card"
            onClick={() => handlePlantSelection(plant)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handlePlantSelection(plant);
              }
            }}
          >
            <div className="plant-card-body">
              {plant.isBasePlant && (
                <span className="base-plant-badge">BASE PLANT</span>
              )}

              <h3 className="plant-name">{plant.plantName}</h3>
              <p className="plant-location">
                {plant.location || "Location not available"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Loading State */}
      {plants.length === 0 && !error && (
        <div className="plant-loading">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading your plants...</p>
        </div>
      )}

      {/* Error State */}
      {/* {error && (
        <div className="plant-error">
          <p>{error}</p>
        </div>
      )} */}

      {/* Error State - without retry button */}
      {error && (
        <div className="plant-error">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default SSOPlant;
